import { DeleteIcon } from '@/components/_common';
import { useSpedDocumentRemove } from '@/core/domain/sped/sped-documents/sped-documents.hooks';
import {
  SpedDocument,
  SpedDocumentStatus,
} from '@/core/domain/sped/sped-documents/sped-documents.types';
import { Modal } from 'antd';

interface Props {
  spedDocument: SpedDocument;
}

export default function SpedDocumentDeleteAction({ spedDocument }: Props) {
  const disabled =
    spedDocument.status !== SpedDocumentStatus.AWAITING_SELECTION;

  const spedDocumentRemove = useSpedDocumentRemove();

  const confirmRemove = () => {
    Modal.confirm({
      title: 'Remoção do documento SPED',
      content:
        'Tem certeza que quer remover o documento SPED? Não será possível reverter.',
      onOk: () => spedDocumentRemove.mutateAsync(spedDocument.id),
      okText: 'Remover',
      okButtonProps: { danger: true },
    });
  };

  return <DeleteIcon disabled={disabled} onClick={confirmRemove} />;
}
